import { render, staticRenderFns } from "./TrashIconButton.vue?vue&type=template&id=1c2a96d2&"
import script from "./TrashIconButton.vue?vue&type=script&lang=js&"
export * from "./TrashIconButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports